<app-navigation *ngIf="authService.isLoggedInPage() && showNavigation"></app-navigation>
<router-outlet *ngIf="!authService.isLoggedInPage()"></router-outlet>